import { enums } from "@ambii-com/core";
import * as localEnums from "@/constants/enums";

export default (context, inject) => {
  inject("enums", enums);
  inject("localEnums", localEnums);
};
